(function (angular) {
    'use strict';

    angular.module('shared')
        .directive('title', ["badgeService", function (badgeService) {

            return ({
                link: link,
                restrict: "E"
            });

            // I bind the JavaScript events to the view-model.
            function link(scope, element, attributes) {
                // Now, let's watch the window title for changes.
                scope.$watch(badgeService.getCount, handleBadgeChange);
                // ---
                // PRIVATE METHODS.
                // ---
                // I handle title changes and update the DOM accordingly.
                function handleBadgeChange(newCount) {
                    var newTitle = newCount === 0 ? "CPaaS Portal" : ("[" + newCount + "] CPaaS Portal");
                    element.text(newTitle);
                }
            }

        }]);
})(window.angular);